import { API } from "@aws-amplify/api";

export const getCounterParts = `query MyQuery($input:cidInput) {
    getCounterParts(input:$input) {
    email
    phone
    }
    }`;



export async function getCounterPartsDetails(customerId:any): Promise<any> {
  try {
//return responseObject;
const response: any = await API.graphql({ query: getCounterParts, variables: {input:{customerId:customerId} } });
console.log(response)
   return response.data.getCounterParts;
  } catch (error) {
    console.log("get Counter Parts", error);
  }
}